<script setup lang="ts">
// The list of a settings screen's sections (user, space, library settings): one row each,
// with a hint of what's in it; choosing one opens it in the same dialog, with Back.
import { nextTick, onMounted } from 'vue'
import Icon from './Icon.vue'

const props = defineProps<{
  sections: { id: string; label: string; hint?: string }[]
  /** The section just left, to put the focus back on its row. */
  from?: string | null
  /** Prefix for the rows' test ids: `<prefix>-<id>`. */
  testid: string
}>()
const emit = defineEmits<{ open: [id: string] }>()

onMounted(() => {
  if (props.from) void nextTick(() => document.getElementById(`${props.testid}-${props.from}`)?.focus())
})
</script>

<template>
  <ul class="-mx-5 -my-5 divide-y divide-border" :data-testid="`${testid}-menu`">
    <li v-for="s in sections" :key="s.id">
      <button
        :id="`${testid}-${s.id}`"
        type="button"
        class="flex min-h-14 w-full items-center gap-3 px-5 py-3 text-left transition-colors hover:bg-bg-hover focus-visible:bg-bg-hover"
        :data-testid="`${testid}-${s.id}`"
        @click="emit('open', s.id)"
      >
        <span class="min-w-0 flex-1 leading-tight">
          <span class="block text-sm text-text-primary">{{ s.label }}</span>
          <span v-if="s.hint" class="mono mt-0.5 block truncate text-text-muted">{{ s.hint }}</span>
        </span>
        <Icon name="right" class="shrink-0 text-text-muted" />
      </button>
    </li>
  </ul>
</template>
